'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeId$() {
  this.c7m = null;
  this.c7n = false;
  this.c7k = null;
  this.c7l = false;
}
export { $c_Lpresto_types$EnvelopeId$ as $c_Lpresto_types$EnvelopeId$ };
$p = $c_Lpresto_types$EnvelopeId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeId$;
/** @constructor */
function $h_Lpresto_types$EnvelopeId$() {
}
export { $h_Lpresto_types$EnvelopeId$ as $h_Lpresto_types$EnvelopeId$ };
$h_Lpresto_types$EnvelopeId$.prototype = $p;
$p.cJ4 = (function() {
  if ((!this.c7n)) {
    this.c7m = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c7n = true;
  }
  return this.c7m;
});
$p.vl = (function() {
  if ((!this.c7l)) {
    this.c7k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c7l = true;
  }
  return this.c7k;
});
var $d_Lpresto_types$EnvelopeId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeId$, "presto.types$EnvelopeId$", ({
  a05: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeId$ as $d_Lpresto_types$EnvelopeId$ };
var $n_Lpresto_types$EnvelopeId$;
function $m_Lpresto_types$EnvelopeId$() {
  if ((!$n_Lpresto_types$EnvelopeId$)) {
    $n_Lpresto_types$EnvelopeId$ = new $c_Lpresto_types$EnvelopeId$();
  }
  return $n_Lpresto_types$EnvelopeId$;
}
export { $m_Lpresto_types$EnvelopeId$ as $m_Lpresto_types$EnvelopeId$ };
//# sourceMappingURL=presto.types$-Envelope-Id$.js.map
